import Fetch from "./Fetch";
import FetchWithSiteId from "./FetchWithSiteId";

import { API_BASIC_URL_SLOT_SERVICE, API_BASIC_URL_POLYGON_SERVICE } from "../config/constants";
import { handleError, handleResponse } from "./ApiUtils";

export const getPosTypes = () => {
  return Fetch.get(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/postypes`).then(handleResponse).catch(handleError);
};

export const getServiceTypes = () => {
  return Fetch.get(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/servicetypes`).then(handleResponse).catch(handleError);
};

export const createPos = (data) => {
  return Fetch.create(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/pos`, data).then(handleResponse).catch(handleError);
};

export const fetchPOSList = (data) => {
  return Fetch.get(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/pos`, data).then(handleResponse).catch(handleError);
};

export const fetchPOSDetails = (posNo) => {
  return Fetch.get(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/pos/${posNo}`).then(handleResponse).catch(handleError);
};

export const updatePOSDetails = (posData) => {
  return Fetch.update(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/pos`, posData).then(handleResponse).catch(handleError);
};

export const fetchTemplateSlots = (posNo, params) => {
  return Fetch.get(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/${posNo}/service-config`, params).then(handleResponse).catch(handleError);
};

export const createTemplateSlots = (posNo, zoneCongifurations) => {
  return Fetch.create(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/${posNo}/service-config`, zoneCongifurations).then(handleResponse).catch(handleError);
};

export const updateTemplateSlots = (posNo, zoneCongifurations) => {
  return Fetch.patch(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/${posNo}/service-config`, zoneCongifurations).then(handleResponse).catch(handleError);
};

export const toggleServiceOfPOS = (posNo, data) => {
  return Fetch.patch(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/pos/${posNo}/activation-toggle?active=${data.active}&serviceType=${data.serviceType}`).then(handleResponse).catch(handleError);
};

export const deleteZoneConfigByZoneId = (data) => {
  return Fetch.patch(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/zone-action/${data.posNo}/${data.serviceTypeName}/${data.zoneId}?status=DELETED`).then(handleResponse).catch(handleError);
};

export const toggleCollectionPoint = (collectionPointId, data) => {
  return Fetch.patch(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/pos/cnc/${collectionPointId}?toggleFlag=${data.toggleFlag}`).then(handleResponse).catch(handleError);
};

export const toggleZoneOfServiceOfPOS = (posNo, data) => {
  return Fetch.patch(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/zone-action/${posNo}/${data.serviceTypeName}/${data.zoneId}?status=${data.activstatus}`).then(handleResponse).catch(handleError);
};

export const toggleZoneServiceableState = (data) => {
  return Fetch.update(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/zone/${data.zoneId}`, data.payload).then(handleResponse).catch(handleError);
};

export const fetchStandardTemplateSlots = (posNo, params) => {
  return Fetch.get(`${API_BASIC_URL_SLOT_SERVICE}/api/v2/${posNo}/service-config`, params).then(handleResponse).catch(handleError);
};
export const createTemplateSlotsForStandard = (posNo, zoneCongifurations) => {
  return Fetch.create(`${API_BASIC_URL_SLOT_SERVICE}/api/v2/${posNo}/service-config`, zoneCongifurations).then(handleResponse).catch(handleError);
};
export const updateTemplateSlotsForStandard = (posNo, zoneCongifurations) => {
  return Fetch.patch(`${API_BASIC_URL_SLOT_SERVICE}/api/v2/${posNo}/service-config`, zoneCongifurations).then(handleResponse).catch(handleError);
};

export const updateDynamicRoutingForStandard = (dynamicRoutingPayload) => {
  return FetchWithSiteId.create(`${API_BASIC_URL_POLYGON_SERVICE}/api/store/v1/mappings/pos-zone`, dynamicRoutingPayload).then(handleResponse).catch(handleError);
};

export const fetchStandardTemplateSlotsVersionThree = (posNo, params) => {
  return Fetch.get(`${API_BASIC_URL_SLOT_SERVICE}/api/v3/${posNo}/service-config`, params).then(handleResponse).catch(handleError);
};

export const saveServiceTypeConfig = (posNo, data) => {
  return Fetch.update(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/${posNo}/service-type-config`, data).then(handleResponse).catch(handleError);
};

export const deletePOS = (posNumber) => {
  return FetchWithSiteId.remove(`${API_BASIC_URL_SLOT_SERVICE}/api/v2/pos?posNo=${posNumber}`).then(handleResponse).catch(handleError);
};